/**
 * Map a generated DesignTokenTheme into an AG Grid Quartz theme.
 *
 * TODO: Resolve design-token colors into AG Grid `withParams` (accent, border, header, etc.).
 */

import { themeQuartz, type Theme as AgGridTheme } from 'ag-grid-community';

import type { DesignTokenTheme } from '@/themes/types';

export function themeTokensToAgGridTheme(_theme: DesignTokenTheme): AgGridTheme {
  // TODO: map design tokens → AG Grid theme params
  return themeQuartz;
}
